// Navigationsleiste: Menue auf dem Handy und der Zustand beim Scrollen.
// (Frueher zwei Dateien, mobileMenu.js und scrolled.js.)

const navBar = document.querySelector('.ce_rsce_navBar');

if (navBar) {
    // Handy-Menue auf und zu. Solange es offen ist, scrollt die Seite
    // dahinter nicht mit - die Klasse dafuer steht in rsce_navBar.scss.
    const mobileMenu = navBar.querySelector('.navMobile');
    const mobileButton = navBar.querySelector('.mobile-menu');

    if (mobileMenu && mobileButton) {
        mobileButton.addEventListener('click', () => {
            const offen = mobileButton.classList.toggle('active');
            mobileMenu.classList.toggle('active', offen);
            document.body.classList.toggle('fn-menue-offen', offen);
        });
    }

    // Ab 100 px Scrollweg bekommt die Leiste ihren kompakten Zustand
    const scrollStand = () => {
        navBar.classList.toggle('scrolled', window.scrollY > 100);
    };

    window.addEventListener('scroll', scrollStand, { passive: true });
    scrollStand();
}
